var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplefiligreeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-dde80036-17f5-419d-84c0-03f5b0feb405",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.31 67.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "67.31 2.12 65.19 0 33.66 31.53 2.12 0 0 2.12 31.53 33.66 0 65.19 2.12 67.31 33.66 35.78 65.19 67.31 67.31 65.19 35.78 33.66 67.31 2.12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplefiligreeClose);
export default __webpack_public_path__ + "static/media/simple filigree - close.2057c3ba109f314ab34b764eee696a88.svg";
export { ForwardRef as ReactComponent };